var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-validator",on:{"input":_vm.controlInput,"change":_vm.controlChange}},[_vm._t("default",null,{"state":_vm.controlState,"feedback":_vm.controlFeedback})],2)}
var staticRenderFns = []

export { render, staticRenderFns }